import { MAPS_RADIUS } from "../../../utils/constants";

export function clampRadiusMeters(value) {
  if (value == null || value === "") {
    return MAPS_RADIUS.MIN_M;
  }
  let num = typeof value === "string" ? parseFloat(value) : Number(value);
  if (Number.isNaN(num) || num <= 0) {
    return MAPS_RADIUS.MIN_M;
  }

  if (num > 0 && num < 1000) {
    num = num * 1000;
  }
  return Math.max(
    MAPS_RADIUS.MIN_M,
    Math.min(MAPS_RADIUS.MAX_M, Math.round(num))
  );
}
